export namespace CoreFileLinkActions {
  export class FetchFileLink {
    static readonly type = '[Core File Link] Fetch File Link';
    constructor(public fileId: string) {}
  }
}
